export const WheelsSearchFilter = [
  { key: 'rimSize', text: 'Filter rim size', checkboxId: 'rimDiameter' },
  { key: 'colorGroup', text: 'Filter color group', checkboxId: 'colorGroup' },
  { key: 'width', text: 'Filter rim width', checkboxId: 'width' },
  // { key: 'cb', text: 'Filter rim center bore', checkboxId: 'cb' },
];
